import { BaseRouteService } from 'core/services';

class DaVinciRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'davinci/';
	}

	getBusinessPartners() {
		return super.find(this.base + 'get-business-partners');
	}
}

export default DaVinciRouteService;
